var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boxInfo" },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { height: "100%" },
          attrs: { type: "border-card", value: "first" },
          on: { "tab-click": _vm.handleTabClick },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label:
                  _vm.typeIndex === 1
                    ? _vm.$t("basicData.AddPartition")
                    : _vm.$t("basicData.PartitionDetails"),
                name: "first",
              },
            },
            [
              _c(
                "div",
                { staticClass: "addFormBox" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "queryForm",
                      staticClass: "queryFormClass",
                      attrs: {
                        model: _vm.formData,
                        rules: _vm.rules,
                        "label-width": _vm.$i18n.locale === "zh" ? "120px" : "",
                        "label-position":
                          _vm.$i18n.locale !== "zh" ? "top" : "right",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "basicData.PartitionSchemeName"
                                    ),
                                    prop: "name",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "orderDetails.pleaseInput"
                                      ),
                                      clearable: "",
                                      maxlength: "20",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.formData.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.businessT"),
                                    prop: "businessType",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                      },
                                      model: {
                                        value: _vm.formData.businessType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "businessType",
                                            $$v
                                          )
                                        },
                                        expression: "formData.businessType",
                                      },
                                    },
                                    _vm._l(_vm.BUSINESS_TYPE, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("basicData.SenderDimension"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        placeholder: _vm.$t(
                                          "basicData.SenderNotParticipate"
                                        ),
                                      },
                                      on: {
                                        change: _vm.receiveDimensionChange,
                                      },
                                      model: {
                                        value: _vm.formData.sendDimension,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "sendDimension",
                                            $$v
                                          )
                                        },
                                        expression: "formData.sendDimension",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        key: "1",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.state"
                                          ),
                                          value: 4,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "2",
                                        attrs: {
                                          label: _vm.$t("placeOrder.area"),
                                          value: 3,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "3",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.city"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "basicData.RecipientDimension"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                      },
                                      on: {
                                        change: _vm.receiveDimensionChange,
                                      },
                                      model: {
                                        value: _vm.formData.receiveDimension,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "receiveDimension",
                                            $$v
                                          )
                                        },
                                        expression: "formData.receiveDimension",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        key: "1",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.state"
                                          ),
                                          value: 4,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "2",
                                        attrs: {
                                          label: _vm.$t("placeOrder.area"),
                                          value: 3,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "3",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.city"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "4",
                                        attrs: {
                                          label: _vm.$t("basicData.zipCode"),
                                          value: 1,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("basicData.RemarkContent"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "orderDetails.pleaseInput"
                                      ),
                                      type: "textarea",
                                      rows: 3,
                                    },
                                    model: {
                                      value: _vm.formData.remark,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "remark", $$v)
                                      },
                                      expression: "formData.remark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "mb10 feet-r" },
                      [
                        _vm.typeIndex !== 3
                          ? [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "but:finance:basicData:partition:edit",
                                      expression:
                                        "'but:finance:basicData:partition:edit'",
                                      arg: "remove",
                                    },
                                  ],
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.handleAdd },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("basicData.AddPartition")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-popover",
                                {
                                  key: _vm.importComponentKey,
                                  attrs: {
                                    placement: "bottom-start",
                                    trigger: "hover",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "reference",
                                        fn: function () {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  plain: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "basicData.ImportDownload"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1601201048
                                  ),
                                },
                                [
                                  _c("import-partition", {
                                    attrs: {
                                      "table-data": _vm.formData,
                                      "sender-dimension":
                                        _vm.senderDimensionValue,
                                      "receiver-dimension":
                                        _vm.receiveDimension,
                                      "state-list": _vm.allState,
                                      "all-city": _vm.allCity,
                                      "area-list": _vm.areaList,
                                    },
                                    on: {
                                      importPartition: _vm.importPartitionData,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.receiveDimension === 1
                          ? _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                placeholder: _vm.$t("basicData.zipCode"),
                                size: "small",
                                clearable: "",
                              },
                              on: { clear: _vm.clearHighlight },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "prepend",
                                    fn: function () {
                                      return [
                                        _vm._v(_vm._s(_vm.receiverColHeader)),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("el-button", {
                                          attrs: { icon: "el-icon-search" },
                                          on: { click: _vm.handleSearch },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3618948249
                              ),
                              model: {
                                value: _vm.searchText,
                                callback: function ($$v) {
                                  _vm.searchText = $$v
                                },
                                expression: "searchText",
                              },
                            })
                          : _c(
                              "div",
                              { staticClass: "select-search" },
                              [
                                _c("span", { staticClass: "search-label" }, [
                                  _vm._v(_vm._s(_vm.receiverColHeader)),
                                ]),
                                _c("ElSelectV2", {
                                  staticStyle: { width: "260px" },
                                  attrs: {
                                    options: _vm.queryReceiverOptions,
                                    filterable: _vm.receiverQueryFilterable,
                                    clearable: "",
                                    size: "small",
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.searchText,
                                    callback: function ($$v) {
                                      _vm.searchText = $$v
                                    },
                                    expression: "searchText",
                                  },
                                }),
                                _c("el-button", {
                                  attrs: {
                                    size: "small",
                                    icon: "el-icon-search",
                                  },
                                  on: { click: _vm.handleSearch },
                                }),
                              ],
                              1
                            ),
                        _c(
                          "el-button-group",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled:
                                    !_vm.hasSearchResults ||
                                    _vm.currentHighlightIndex <= 0,
                                  size: "small",
                                  icon: "el-icon-arrow-left",
                                },
                                on: { click: _vm.highlightPrev },
                              },
                              [_vm._v(_vm._s(_vm.$t("mdfeTranslate.Previous")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: !_vm.hasSearchResults,
                                  size: "small",
                                  type: "primary",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currentHighlightIndex + 1) +
                                    "/" +
                                    _vm._s(_vm.searchResults.length) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled:
                                    !_vm.hasSearchResults ||
                                    _vm.currentHighlightIndex >=
                                      _vm.searchResults.length - 1,
                                  size: "small",
                                },
                                on: { click: _vm.highlightNext },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.Next")) + " "
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-right el-icon--right",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "virtual-scroll",
                          {
                            key: _vm.key,
                            ref: "virtualScroll",
                            attrs: {
                              data: _vm.formData.partitionAffiliateList,
                              "item-size": 76,
                              "key-prop": "key",
                            },
                            on: { change: _vm.onVirtualChange },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                ref: "tableRef",
                                attrs: {
                                  data: _vm.list,
                                  "row-key": "key",
                                  border: "",
                                  height: "500",
                                  "row-class-name": _vm.getRowClassName,
                                  "highlight-current-row": false,
                                },
                              },
                              [
                                _c("virtual-column", {
                                  attrs: { width: "80", type: "index" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("basicData.PartitionName"),
                                    width: "160",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "basicData.PartitionName"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            attrs: {
                                              maxlength: "50",
                                              "show-word-limit": "",
                                              placeholder: _vm.$t(
                                                "basicData.PartitionName"
                                              ),
                                            },
                                            model: {
                                              value:
                                                scope.row.partitionIdentifier,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "partitionIdentifier",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.partitionIdentifier",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.senderColHeader,
                                    width: "230",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _vm.senderSelected
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [_vm._v("*")]
                                                )
                                              : _vm._e(),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.senderColHeader)
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.senderDimensionValue === 4
                                            ? [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      clearable: "",
                                                      filterable: "",
                                                      placeholder: _vm.$t(
                                                        "GlobalSetObj.pleaseChoose"
                                                      ),
                                                    },
                                                    model: {
                                                      value: scope.row.state,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "state",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.state",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.stateOptions,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.value,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            : _vm.senderDimensionValue === 3
                                            ? [
                                                _c("ElSelectV2", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    filterable: "",
                                                    options: _vm.areaOptions,
                                                    placeholder: _vm.$t(
                                                      "GlobalSetObj.pleaseChoose"
                                                    ),
                                                  },
                                                  model: {
                                                    value: scope.row.state,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.state",
                                                  },
                                                }),
                                              ]
                                            : _vm.senderDimensionValue === 2
                                            ? [
                                                _c("ElSelectV2", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    filterable: "",
                                                    options: _vm.cityOptions,
                                                    placeholder: _vm.$t(
                                                      "GlobalSetObj.pleaseChoose"
                                                    ),
                                                  },
                                                  model: {
                                                    value: scope.row.state,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.state",
                                                  },
                                                }),
                                              ]
                                            : [
                                                _c("el-select", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    disabled: "",
                                                    placeholder: _vm.$t(
                                                      "GlobalSetObj.pleaseChoose"
                                                    ),
                                                  },
                                                  model: {
                                                    value: scope.row.state,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.state",
                                                  },
                                                }),
                                              ],
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: { "min-width": "320" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.receiverColHeader)
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.receiveDimension === 1
                                            ? _c("el-input", {
                                                attrs: {
                                                  type: "textarea",
                                                  rows: 2,
                                                  placeholder: _vm.$t(
                                                    "basicData.ZipCodeExample"
                                                  ),
                                                },
                                                model: {
                                                  value: scope.row.postalCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "postalCode",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.postalCode",
                                                },
                                              })
                                            : _vm.receiveDimension === 4
                                            ? _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    multiple: "",
                                                    clearable: "",
                                                    filterable: "",
                                                    "collapse-tags": "",
                                                    placeholder: _vm.$t(
                                                      "GlobalSetObj.pleaseChoose"
                                                    ),
                                                  },
                                                  model: {
                                                    value: scope.row.city,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "city",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.city",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.stateOptions,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.value,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm.receiveDimension === 3
                                            ? _c("ElSelectV2", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  multiple: "",
                                                  clearable: "",
                                                  filterable: "",
                                                  "collapse-tags": "",
                                                  options: _vm.areaOptions,
                                                  placeholder: _vm.$t(
                                                    "GlobalSetObj.pleaseChoose"
                                                  ),
                                                },
                                                model: {
                                                  value: scope.row.city,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "city",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.city",
                                                },
                                              })
                                            : _c("ElSelectV2", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  multiple: "",
                                                  clearable: "",
                                                  filterable: "",
                                                  "collapse-tags": "",
                                                  options: _vm.cityOptions,
                                                  placeholder: _vm.$t(
                                                    "GlobalSetObj.pleaseChoose"
                                                  ),
                                                },
                                                model: {
                                                  value: scope.row.city,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "city",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.city",
                                                },
                                              }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("basicData.operate"),
                                    width: "120",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-popconfirm", {
                                            attrs: {
                                              title: _vm.$t(
                                                "basicData.AreYouSureYouWantToDelete"
                                              ),
                                            },
                                            on: {
                                              confirm: function ($event) {
                                                return _vm.handleDel(scope)
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "reference",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "danger",
                                                            size: "mini",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "basicData.Delete"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "addFooter" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function () {
                          return _vm.handleUpdatePage(false)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "but:finance:basicData:partition:edit",
                          expression: "'but:finance:basicData:partition:edit'",
                          arg: "remove",
                        },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.Save")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm.typeIndex === 2
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("basicData.OperationalLogs"),
                    name: "second",
                  },
                },
                [
                  _vm.isSecondActive
                    ? _c("operation-log", {
                        attrs: {
                          "edit-data": _vm.editData,
                          "all-city": _vm.allCity,
                          "all-state": _vm.allState,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("basicData.tips"),
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm._l(_vm.errData, function (item, ind) {
            return _c(
              "div",
              {
                key: ind,
                staticStyle: { color: "red", "margin-bottom": "10px" },
              },
              [_vm._v(_vm._s(item))]
            )
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }